// extracted by mini-css-extract-plugin
export default {"scrollableContainer":"Nj57Yv"};